import React, { useEffect, useState } from "react";
import { Form, Button, Row, Col } from "react-bootstrap";
import { useForm, useFieldArray } from "react-hook-form";
import Axios from "axios";
import moment from "moment-timezone";

import { dirname } from "../../../../../util/resourcePath";
import { useRouter } from "../../../../../util/router";
import { useUser } from "../../../../../util/user";
import GYAxios from "../../../../../util/GYAxios";
import Noti from "../../../../../util/noti";
import { sendUserCreatedUpdatedEmail } from "../../../../../util/email";

import UserFormElement from "./UserFormElement";

import "./UsersForm.css";
import { setEditingClientUsersLocalStorage } from "../../../../../util/clientUsersFormContext";

const FormBody = (props) => {
	const directory = dirname();
	const loggedInUser = useUser();
	const router = useRouter();
	const [clientID, setClientID] = useState("");
	const [siteID, setSiteID] = useState("");
	const [slug, setSlug] = useState("");
	const [isLIP, setIsLIP] = useState(false);
	const [isSolo, setIsSolo] = useState(false);
	const [isEditMode, setIsEditMode] = useState(true);
	const [tempFields, setTempFields] = useState([]);
	const [siteSelectOptions, setSiteSelectOptions] = useState([]);
	// const [deleteIDs, setDeleteIDs] = useState([]);
	const [isLoading, setIsLoading] = useState(true);
	const [showIndiviSitesSelect, setShowIndiviSitesSelect] = useState([
		"usersObj[0]",
	]);
	const existingUsers = props.existingUsers;
	const formMode = props.formMode;
	const setReload = props.setReload;

	const formBtnStyle = {
		width: "10%",
		minWidth: "100px",
		margin: "auto",
		display: "block",
	};

	const defaultUserObj = {
		dept_id: 7,
		email: "",
		first_name: "",
		last_name: "",
		nick_name: "",
		position: "",
		site_id: "",
		user_id: "",
		seesAllSites: !isLIP,
		seesInvoices: true,
		seesReports: true,
		receivingEInvoice: false,
	};

	const defaultUsers = props.users.length > 0 ? props.users : [defaultUserObj];
	const { register, control, handleSubmit, getValues, setValue, errors, reset } = 
		useForm({ defaultValues: { usersObj: defaultUsers } });

	const { fields, append, remove } = useFieldArray({
		control,
		name: "usersObj",
	});

	/**
	 * Reset form data to defaultUsers
	 */
	const resetForm = () => {
		remove();
		setTimeout(reset);
	}

	/**
	 * Fetch select options of client ID
	 * @param {string} clientID
	 */
	const fetchFormSelectOptions = (clientID) => {
		const sitesURI = GYAxios.get(`/select/sites/client/${clientID}`);

		const reqArray = [sitesURI];

		Axios.all(reqArray).then(
			Axios.spread((...responses) => {
				const resSites = !responses[0].data.error ? responses[0].data : [];
				setSiteSelectOptions(resSites);
				setIsLoading(false);
			})
		);
	};

	/**
	 * Handle form submit
	 * @param {obj} data
	 */
	const onSubmit = (submittedData) => {
		const process = formMode === "NEW" ? "add new" : formMode.toLowerCase();
		const confirmSubmit = window.confirm(`Confirm ${process} users?`);

		if (confirmSubmit) {
			const userID = loggedInUser.preferred_username;
			const now = moment().format("YYYY-MM-DD HH:mm:ss");

			const formattedUsers = submittedData.usersObj.map(prepareUser);

			// Existing users
			const existingUsers = formattedUsers.filter((user) => user.user_id != "");
			const updateReqObjs = existingUsers.map((user) => ({ type: 'UPDATE', req: getUpdateReq(userID, now, user), user }));

			// New users
			const newUsers = formattedUsers.filter((user) => user.user_id == "");
			const insertReqObjs = newUsers.map((user) => ({ type: 'NEW', req: getInsertReq(userID, now, user), user }));

			// Removed users
			// const deleteRequests = deleteIDs.map((id) => ({ type: 'DELETE', req: getDeleteReq(id), userId: id }));

			const reqObjs = [...updateReqObjs, ...insertReqObjs];

			// Making API requests
			Axios.all(reqObjs.map(reqObj => reqObj.req)).then(
				Axios.spread(async (...responses) => {
					// handle errors
					const updateErrorEntries = Object.entries(responses).filter(resEntry => resEntry[1].data.affectedRows !== 1 && resEntry[1].data.serverStatus !== 2);
					if (updateErrorEntries.length > 0) {
						const errorUserEmails = updateErrorEntries.map(resEntry => reqObjs[parseInt(resEntry['0'])].user.email).join(", ");
						Noti.create({
							type: "e",
							msg: "Update Error! Please contact IT",
							title: errorUserEmails
						});
					}
					// no errors
					const updateSuccessEntries = Object.entries(responses).filter(resEntry => resEntry[1].data.affectedRows === 1 && resEntry[1].data.serverStatus === 2);
					if(updateSuccessEntries.length > 0) {
						const successUserEmails = updateSuccessEntries.map(resEntry => reqObjs[parseInt(resEntry[0])].user.email).join(", ");
						Noti.create({
							type: "s",
							msg: "Users Updated Successfully",
							title: successUserEmails
						});
					}
					// send email (group by operations: NEW | UPDATE)
					if(updateSuccessEntries.length > 0) {
						const currentUser = {name: loggedInUser.name, email: loggedInUser.email, username: loggedInUser.preferred_username};
						const successResIndices = updateSuccessEntries.map(resEntry => parseInt(resEntry[0]));
						const insertedUsers = reqObjs.filter((reqObj, index) => successResIndices.includes(index) && reqObj.type === 'NEW').map(reqObj => reqObj.user);
						const updatedUsers = reqObjs.filter((reqObj, index) => successResIndices.includes(index) && reqObj.type === 'UPDATE').map(reqObj => reqObj.user);
						if(insertedUsers.length) { sendUserCreatedUpdatedEmail({ clientId: props.client.id, clientName: props.client.company, country: props.client.country, users: insertedUsers, originalUsers: props.users, operationType: 'NEW', currentUser, sites: siteSelectOptions }) }
						if(updatedUsers.length)  { sendUserCreatedUpdatedEmail({ clientId: props.client.id, clientName: props.client.company, country: props.client.country, users: updatedUsers, originalUsers: props.users, operationType: 'UPDATE', currentUser, sites: siteSelectOptions }) }
					}
					// Return to client user table
					if(updateErrorEntries.length === 0) {
						setTimeout(
							() => router.replace(`/solar/administration/users/clients`),
							1300
						);
					}
				})
			);
		}
		// remove selected user IDs from localStorage
		setEditingClientUsersLocalStorage(null);
	};

	/**
	 * Prepare user obj for form submission
	 * @param {obj} user
	 * @returns Formatter user obj
	 */
	const prepareUser = user => {
		const see_invoice = user.seesInvoices;
		const see_report = user.seesReports;
		const receiving_einvoice = user.receivingEInvoice;

		let site_id = "";

		// Solo site client users
		if (isSolo) site_id = siteID;
		// Multi site client users with access to all sites
		else if (user.seesAllSites) site_id = "all";
		// Users with access to single/multiple sites
		else site_id = user.site_id;

		const formattedUser = {
			...user,
			site_id,
			see_invoice,
			see_report,
			receiving_einvoice,
		};

		delete formattedUser.seesAllSites;
		delete formattedUser.seesInvoices;
		delete formattedUser.seesReports;
		delete formattedUser.receivingEInvoice;

		return formattedUser;
	};

	/**
	 * Get Update users promises
	 * @param {string} userID
	 * @param {datetime} now
	 * @param {obj} user
	 * @returns Update user Promise
	 */
	const getUpdateReq = (userID, now, _user) => {
		let user = {..._user};
		try {
			// Update URI
			const usersURI = `/users/${user.user_id}`;

			// mark exported_status to false
			user.exported_status = false;

			// Remove unnecessary props
			delete user.user_id;
			delete user.email;
			if (user.nick_name === "") delete user.nick_name;

			// last updated data object
			const lastUpdateData = {
				last_updated_by: userID,
				last_updated: now,
			};

			user = { ...user, ...lastUpdateData };

			// Promise
			const updateReq = GYAxios.patch(usersURI, user);

			return updateReq;
		} catch (error) {
			console.log("UPDATE error :", error);

			Noti.create({
				type: "e",
				msg: "Update Error! Please contact IT",
			});
		}
	};

	/**
	 * Get Insert users promises
	 * @param {*} userID
	 * @param {*} now
	 * @param {*} user
	 * @returns Insert user Promise
	 */
	const getInsertReq = (userID, now, _user) => {
		let user = {..._user};
		try {
			// Insert URI
			const usersURI = "/users/new";

			// Remove unnecessary props
			delete user.user_id;
			if (user.nick_name === "") delete user.nick_name;

			// Additional data
			// const emailSplit = user.email.split("@");
			// const username = emailSplit[0];
			const username = user.email;

			const country = props.client.country;

			const addtlData = {
				type: 2,
				username,
				country,
				client_id: props.client.id,
				created_by: userID,
				created_at: now,
				last_updated_by: userID,
				last_updated: now,
			};

			user = { ...user, ...addtlData };

			// Promise
			const insertReq = GYAxios.post(usersURI, user);

			return insertReq;
		} catch (error) {
			console.log("INSERT error :", error);

			Noti.create({
				type: "e",
				msg: "Update Error! Please contact IT",
			});
		}
	};

	/**
	 * Get Delete user promise
	 * @param {string} userID
	 * @returns Delete user Promise
	 */
	const getDeleteReq = (userID) => {
		const deleteURI = `/users/${userID}`;
		const deleteReq = GYAxios.delete(deleteURI);

		return deleteReq;
	};

	/**
	 * Append new user to the form
	 */
	const appendNewUser = () => append(defaultUserObj);

	/**
	 * Fetch site ID of solo site client
	 * @param {string} clientID
	 */
	const fetchSoloSite = (clientID) => {
		const URI = `/site/filter/client_id/${clientID}`;

		GYAxios.get(URI).then((res) => {
			const response = res.data.error == null ? res.data[0]?.site_id : "";
			setSiteID(response);
		});
	};

	useEffect(() => {
		const roles = loggedInUser.roles;
		const hasEditRole = roles.includes(
			"administration:ClientUsersContent:_edit"
		);

		setIsEditMode(hasEditRole);
	}, [loggedInUser.roles]);

	useEffect(() => {
		if (props.client) {
			if (clientID != props.client.id) {
				setClientID(props.client.id);
				setSlug(props.client.slug);

				const isLIPTemp = props.client.id == 27;
				const isSoloTemp = props.client.is_solo == 1;

				setIsLIP(isLIPTemp);
				setIsSolo(isSoloTemp);
			}

			fetchFormSelectOptions(props.client.id);
		}
	}, [props.client]);

	useEffect(() => {
		if (siteSelectOptions.length > 0) {
			const showIndivSiteSelectArray = [];

			for (let i = 0; i < fields.length; i++) {
				const itemName = `usersObj[${i}]`;
				const fieldItem = fields[i];

				if (!fieldItem.seesAllSites) showIndivSiteSelectArray.push(itemName);

				const siteIDStr = fieldItem.site_id;
				let selectedIndivSites = [];

				if (siteIDStr == "all" || siteIDStr == "") selectedIndivSites = [];
				else {
					const siteIDArray = siteIDStr.split(",");

					selectedIndivSites = siteSelectOptions.filter((sites) =>
						siteIDArray.includes(sites.site_id.toString())
					);
				}
				fieldItem.selectedSites = selectedIndivSites;
			}
		}
	}, [siteSelectOptions]);

	// Handle re-render if more users are added
	useEffect(() => {
		if (fields.length != tempFields.length) setTempFields(fields);
	}, [fields]);

	useEffect(() => {
		const seesAllSites = tempFields.map((fieldItem) => fieldItem.seesAllSites);
		const seesAllSitesEntries = Object.entries(seesAllSites);

		const filteredEntries = isLIP
			? seesAllSitesEntries
			: seesAllSitesEntries.filter((entry) => !entry[1]);
		const userIDs = filteredEntries.map((entry) => parseInt(entry[0]));

		const showIndivSiteSelectArray = [];

		userIDs.forEach((id) => {
			showIndivSiteSelectArray.push(`usersObj[${id}]`);
		});

		setShowIndiviSitesSelect(showIndivSiteSelectArray);
	}, [isLIP, tempFields]);

	useEffect(() => {
		if (isSolo) fetchSoloSite(clientID);
	}, [isSolo]);

	return (
		<div>
			<Form onSubmit={handleSubmit(onSubmit)} id="client-users-form">
				{fields.map((item, index) => (
					<UserFormElement
						key={index}
						item={item}
						index={index}
						errors={errors}
						register={register}
						control={control}
						setValue={setValue}
						remove={remove}
						isLoading={isLoading}
						isLIP={isLIP}
						isSolo={isSolo}
						isEditMode={isEditMode}
						siteSelectOptions={siteSelectOptions}
						existingUsers={existingUsers}
						showIndiviSitesSelect={showIndiviSitesSelect}
						setShowIndiviSitesSelect={setShowIndiviSitesSelect}
						// deleteIDs={deleteIDs}
						// setDeleteIDs={setDeleteIDs}
					/>
				))}

				{isEditMode && (
					<>
						<img
							src={`${directory}/images/add-form2.png`}
							alt="add user"
							style={{
								width: "5%",
								cursor: "pointer",
								opacity: "0.5",
								margin: "auto",
								display: "block",
							}}
							title="Add User"
							onClick={appendNewUser}
						/>
						<Row>
							<Col md="6">
								<Button
									variant="Secondary"
									style={formBtnStyle}
									onClick={resetForm}
								>
									Reset
								</Button>
							</Col>
							<Col md="6">
								<Button
									variant="primary"
									style={formBtnStyle}
									type="submit"
									disabled={fields.length == 0}
								>
									Submit
								</Button>
							</Col>
						</Row>
					</>
				)}
			</Form>
			<Noti />
		</div>
	);
};

export default FormBody;
